/* eslint-disable no-console */
export default function logDebug(...args) {
  if (window.location.search.indexOf('hs_debug_interactive') > -1 || window.location.host.includes('local.hsappstatic')) {
    console.log('[web-interactives-embed]', ...args);
    // detect selenium
    if (window.location.search.indexOf('hs_is_selenium') > -1) {
      console.log(...[...args].map(arg => JSON.stringify(arg)));
    }
  }
}